<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="用户">
<!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                  <GridSelect
                      style='width: 177px'
                      title='选择用户'
                      labelName='userName'
                      labelValue='id'
                      :value='queryForm.userId'
                      :limit='1'
                      size='small'
                      placeholder='请选择用户'
                      @getValue='(value) => {queryForm.userId = value}'
                      :columns="USER_code"
                      :searchs="USER_search"
                      dataListUrl='/mpp/user/findList'
                      entityBeanName='mppUser'
                      queryEntityUrl='/mpp/user/get'
                  >
                  </GridSelect>
              </el-form-item>
              <el-form-item label="组织类型">
                  <el-select style='width: 177px;' v-model="queryForm.orgType" placeholder="请选择" clearable size="small">
                      <el-option :value="1" label="店铺">
                      </el-option>
                      <el-option :value="2" label="门店">
                      </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="组织" v-if="queryForm.orgType">
<!--                  <el-input style='width: 177px' v-model="queryForm.orgId"></el-input>-->
                  <GridSelectU
                      style="width: 177px"
                      v-if="queryForm.orgType == 2"
                      title="选择门店"
                      labelName="storeName"
                      labelValue="id"
                      :value="queryForm.orgId"
                      :limit="1"
                      size="small"
                      placeholder="请选择门店"
                      @getValue="(value) => {queryForm.orgId = value}"
                      :columns="STORE_code"
                      :searchs="STORE_search"
                      dataListUrl="/shop/store/findList"
                      entityBeanName="shopStore"
                      queryEntityUrl="/shop/store/get"
                  >
                  </GridSelectU>

                  <GridSelectU
                      v-if="queryForm.orgType == 1"
                      style="width: 177px"
                      title="选择店铺"
                      labelName="shopName"
                      labelValue="id"
                      :value="queryForm.orgId"
                      :limit="1"
                      size="small"
                      placeholder="请选择店铺"
                      @getValue="(value) => {queryForm.orgId = value}"
                      :columns="SHOP_code"
                      :searchs="SHOP_search"
                      dataListUrl="/mall/shop/findList"
                      entityBeanName="mallShop"
                      queryEntityUrl="/mall/shop/get"
                  >
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="来源">
                  <el-select style='width: 177px;' v-model="queryForm.isHand" placeholder="请选择" clearable size="small">
                      <el-option value="1" label="手动">
                      </el-option>
                      <el-option value="2" label="自动">
                      </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="是否结束">
<!--                  <el-input  v-model="queryForm.isOver"></el-input>-->
                  <el-select style='width: 177px;' v-model="queryForm.isOver" placeholder="请选择" clearable size="small">
                      <el-option :value="1" label="是">
                      </el-option>
                      <el-option :value="0" label="否">
                      </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="时间">
                  <el-date-picker
                      style="width: 180px"
                      v-model="timeRange"
                      type="datetimerange"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="-"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                  >
                  </el-date-picker>
              </el-form-item>
              <el-form-item label="备注">
                  <el-input style='width: 177px' v-model="queryForm.remark" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getShopIncomeVoucherList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addShopIncomeVoucher"
        >新建</el-button>

          <span class="count">消费凭证:{{countObj.money1Count}}</span>
          <span class="count">补贴凭证:{{countObj.money2Count}}</span>
          <span class="count">动券宝:{{countObj.money3Count}}</span>
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editShopIncomeVoucher(null)"-->
<!--        >修改</el-button>-->
<!--        <el-button-->
<!--          type="danger"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-delete"-->
<!--          :disabled="multipleSelection.length <= 0"-->
<!--          @click="deleteShopIncomeVoucher(null)"-->
<!--        >删除</el-button>-->
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
            title="导出数据"
            class="icon-box"
            @click="exportShopIncomeVoucherList"
        >
            <Icon color="#606266">
            <ArrowDownload24Regular />
            </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshShopIncomeVoucherList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="shopIncomeVoucherList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        min-width="140"
      >
          <template slot-scope='scope'>
              <div v-if="scope.row.user">
                  <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                  <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                  <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                  <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orgType"
        label="组织类型"
        min-width="90"
      >
          <template slot-scope='scope'>
              {{ scope.row.orgType == 1 ? '店铺' : (scope.row.orgType == 2 ? '门店' : '--') }}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="false"
        align="center"
        prop="orgId"
        label="组织名称"
        min-width="90"
      >
          <template slot-scope='scope'>
              <div v-if="scope.row.shop && scope.row.orgType == 1">
                  <div style="text-align: left">{{ scope.row.shop.shopName ? scope.row.shop.shopName : '--' }}</div>
              </div>
              <div v-else-if="scope.row.store && scope.row.orgType == 2">
                  <div style="text-align: left">{{ scope.row.store.storeName ? scope.row.store.storeName : '--' }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="false"
        align="center"
        prop="orderId"
        label="订单"
        min-width="100"
      > </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="money1"
            label="消费凭证"
            width="90"
        >
        </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="money2"
        label="补贴凭证"
        min-width="90"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="money3"
        label="动券宝"
        min-width="90"
      > </el-table-column>



      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sendRatio"
        label="已补贴比例范围"
        min-width="140"
      > </el-table-column>
	  
	  <el-table-column
	    :show-overflow-tooltip="true"
	    align="center"
	    prop="effectiveRatio"
	    label="有效加权比例"
	    min-width="130"
	  > </el-table-column>
	  
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="periods"
        label="期数"
        min-width="70"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="lastMoney"
        label="最后一期补贴金额"
        min-width="140"
      > </el-table-column>
	  <el-table-column
	    :show-overflow-tooltip="true"
	    align="center"
	    prop="totalMoney"
	    label="共计补贴金额"
	    min-width="140"
	  > </el-table-column>
	  <el-table-column
	    :show-overflow-tooltip="true"
	    align="center"
	    prop="sendStatus"
	    label="执行状态"
	    min-width="90"
	  > 
	  <template slot-scope='scope'>
	          <div v-if="scope.row.sendStatus == 1">发放中...</div>
	          <div v-else>否</div>
	      </template>
	  </el-table-column>
	  <el-table-column
	    :show-overflow-tooltip="true"
	    align="center"
	    prop="inSubsidy"
	    label="是否在补贴"
	    min-width="110"
	  >
	  <template slot-scope='scope'>
              <div v-if="scope.row.inSubsidy == 1">是</div>
              <div v-else>否</div>
          </template>
      </el-table-column>
	  
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="isOver"
        label="是否结束"
        min-width="90"
      >
          <template slot-scope='scope'>
              <div v-if="scope.row.isOver == 1">是</div>
              <div v-else>否</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        min-width="150"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="remark"
        label="备注"
        min-width="200"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="200"
      >
        <template slot-scope="scop">
          <div class="operation">
              <div @click="openRecordDialog(scop.row.id)">
                  <Icon size="16">
                      <Eye24Regular />
                  </Icon>
                  <span class="operation-label">查看记录</span>
              </div>
<!--            <div @click="checkShopIncomeVoucher(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Eye24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">查看</span>-->
<!--            </div>-->
<!--            <div @click="editShopIncomeVoucher(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
            <div @click="deleteShopIncomeVoucher(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="shopIncomeVoucherStates[shopIncomeVoucherState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="shopIncomeVoucher"
          ref="shopIncomeVoucherForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
            <el-form-item
                label="消费类型"
                prop="consumptionType"
            >
                <el-select style='width: 177px;' v-model="shopIncomeVoucher.consumptionType" :disabled="shopIncomeVoucherState == 'check'" placeholder="请选择" clearable size="small">
                    <el-option :value="1" label="双向补贴">
                    </el-option>
                    <el-option :value="2" label="单补用户">
                    </el-option>
                    <el-option :value="3" label="单补商户">
                    </el-option>
                </el-select>
            </el-form-item>
          <el-form-item
            label="用户"
            prop="userId"
            v-if="shopIncomeVoucher.consumptionType == 1 || shopIncomeVoucher.consumptionType == 2"
          >
              <GridSelect
                  :disabled="shopIncomeVoucherState == 'check'"
                  style='width: 177px'
                  title='选择用户'
                  labelName='userName'
                  labelValue='id'
                  :value='shopIncomeVoucher.userId'
                  :limit='1'
                  size='small'
                  placeholder='请选择用户'
                  @getValue='(value) => {shopIncomeVoucher.userId = value}'
                  :columns="USER_code"
                  :searchs="USER_search"
                  dataListUrl='/mpp/user/findList'
                  entityBeanName='mppUser'
                  queryEntityUrl='/mpp/user/get'
              >
              </GridSelect>
          </el-form-item>
            <el-form-item
                label="是否发放"
                prop="isSend"
                v-if="shopIncomeVoucher.consumptionType == 1"
            >
                <el-select style='width: 177px;' v-model="shopIncomeVoucher.isSend" :disabled="shopIncomeVoucherState == 'check'" placeholder="请选择" clearable size="small">
                    <el-option :value="1" label="是">
                    </el-option>
                    <el-option :value="0" label="否">
                    </el-option>
                </el-select>
            </el-form-item>
          <el-form-item
            label="门店名称"
            prop="orgId"
            v-if="shopIncomeVoucher.consumptionType == 1 || shopIncomeVoucher.consumptionType == 3"
          >
              <GridSelectLi
                  v-if="shopIncomeVoucher.orgType == 2"
                  style="width: 177px"
                  title="选择门店"
                  labelName="storeName"
                  :disabled="shopIncomeVoucherState == 'check'"
                  labelValue="id"
                  :value="shopIncomeVoucher.orgId"
                  :limit="1"
                  size="small"
                  placeholder="请选择门店"
                  @getValue="(value) => {shopIncomeVoucher.orgId = value}"
                  :columns="STORE_code"
                  :searchs="STORE_search"
                  dataListUrl="/shop/store/findList"
                  entityBeanName="shopStore"
                  queryEntityUrl="/shop/store/get"
              >
              </GridSelectLi>

              <GridSelectU
                  v-if="shopIncomeVoucher.orgType == 1"
                  style="width: 177px"
                  title="选择店铺"
                  labelName="shopName"
                  :disabled="shopIncomeVoucherState == 'check'"
                  labelValue="id"
                  :value="shopIncomeVoucher.orgId"
                  :limit="1"
                  size="small"
                  placeholder="请选择店铺"
                  @getValue="(value) => {shopIncomeVoucher.orgId = value}"
                  :columns="SHOP_code"
                  :searchs="SHOP_search"
                  dataListUrl="/mall/shop/findList"
                  entityBeanName="mallShop"
                  queryEntityUrl="/mall/shop/get"
              >
              </GridSelectU>
          </el-form-item>
<!--          <el-form-item-->
<!--            label="订单"-->
<!--            prop="orderId"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              style='width: 177px'-->
<!--              v-model="shopIncomeVoucher.orderId"-->
<!--              :disabled="shopIncomeVoucherState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
<!--            <el-form-item-->
<!--                label="消费凭证"-->
<!--                prop="money1"-->
<!--            >-->
<!--                <el-input-->
<!--                  size="small"-->
<!--                  style='width: 177px'-->
<!--                  v-model="shopIncomeVoucher.money1"-->
<!--                  :disabled="shopIncomeVoucherState == 'check'"-->
<!--                ></el-input>-->
<!--            </el-form-item>-->
<!--          <el-form-item-->
<!--            label="贡献值"-->
<!--            prop="money2"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              style='width: 177px'-->
<!--              v-model="shopIncomeVoucher.money2"-->
<!--              :disabled="shopIncomeVoucherState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
            <el-form-item
                label="服务费类型"
                prop="serviceRadio"
            >
                <el-select style='width: 177px;' v-model="shopIncomeVoucher.serviceRadio" :disabled="shopIncomeVoucherState == 'check'" placeholder="请选择" clearable size="small">
                    <el-option v-for="(item,index) in serviveTypeList" :value="item.value" :label="item.value" :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item
                label="消费金额"
                prop="money"
            >
                <el-input
                    size="small"
                    style='width: 177px'
                    v-model="shopIncomeVoucher.money"
                    :disabled="shopIncomeVoucherState == 'check'"
                ></el-input>
            </el-form-item>
<!--          <el-form-item-->
<!--            label="消费券额度"-->
<!--            prop="money3"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              style='width: 177px'-->
<!--              v-model="shopIncomeVoucher.money3"-->
<!--              :disabled="shopIncomeVoucherState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item-->
<!--            label="动券宝额度"-->
<!--            prop="money4"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              style='width: 177px'-->
<!--              v-model="shopIncomeVoucher.money4"-->
<!--              :disabled="shopIncomeVoucherState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item-->
<!--            label="第一期比例"-->
<!--            prop="firstRatio"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              style='width: 177px'-->
<!--              v-model="shopIncomeVoucher.firstRatio"-->
<!--              :disabled="shopIncomeVoucherState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item-->
<!--            label="期数"-->
<!--            prop="periods"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              style='width: 177px'-->
<!--              v-model="shopIncomeVoucher.periods"-->
<!--              :disabled="shopIncomeVoucherState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item-->
<!--            label="最后一期补贴金额"-->
<!--            prop="lastMoney"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              style='width: 177px'-->
<!--              v-model="shopIncomeVoucher.lastMoney"-->
<!--              :disabled="shopIncomeVoucherState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item-->
<!--            label="是否结束"-->
<!--            prop="isOver"-->
<!--          >-->
<!--              <el-select style='width: 177px;' v-model="shopIncomeVoucher.isOver" :disabled="shopIncomeVoucherState == 'check'" placeholder="请选择" clearable size="small">-->
<!--                  <el-option :value="1" label="是">-->
<!--                  </el-option>-->
<!--                  <el-option :value="0" label="否">-->
<!--                  </el-option>-->
<!--              </el-select>-->
<!--          </el-form-item>-->

            <el-form-item
                label="备注"
                prop="remark"
            >
                <el-input
                    type="textarea"
                    style='width: 177px'
                    v-model="shopIncomeVoucher.remark"
                ></el-input>
            </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="shopIncomeVoucherState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>

      <!--   补贴记录管理   -->
      <el-drawer
          title="补贴记录管理"
          :visible.sync="showRecordDialog"
          direction="rtl"
          size="70%"
          :before-close="closeRecordDialog">
          <ShopIncomeVoucherRecord ref="record"></ShopIncomeVoucherRecord>
      </el-drawer>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import GridSelect from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';
import { SHOP, SHOP_SEARCH, STORE, STORE_SEARCH, UPLOAD_API, UPLOAD_PATH } from '@/utils/constant';
import GridSelectLi from '@/components/gridselect/gidselect.vue';
import GridSelectU from '@/components/gridselect/index.vue';
import ShopIncomeVoucherRecord from '@/components/StoreManagement/ShopIncomeVoucherRecord.vue';

export default {
    components: {
        ShopIncomeVoucherRecord,
        GridSelectU,
        GridSelectLi,
        GridSelect,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopIncomeVoucherList();
                    this.getShopIncomeVoucherList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopIncomeVoucherList();
                    this.getShopIncomeVoucherList();
                    this.$emit('resetCheckState');
                }
            },
            'shopIncomeVoucher.orgType'(id, oldId) {
                if(id == oldId){
                    return;
                }
                if (!this.getOrgType) {
                    this.shopIncomeVoucher.orgId = '';
                } else {
                    this.getOrgType = !this.getOrgType;
                }
            },
            'queryForm.orgType'(id, oldId) {
                if(id == oldId){
                    return;
                }
                this.queryForm.orgId = '';
            },
        },
    data() {
        var checkUser = (rule, value, callback) => {
            if(this.shopIncomeVoucher.userId || this.shopIncomeVoucher.orgId){
                callback();
            }else{
                callback(new Error('请选择'));
            }
        };
            return {
                queryForm:{
                     userId: '', //用户ID
                     orgType: '', //组织类型(1店铺,2门店)
                     orgId: '', //组织ID
                     orderId: '', //订单ID
                     money1: '', //消费凭证
                     money2: '', //贡献值
                     money3: '', //消费券额度
                     money4: '', //动券宝额度
                     firstRatio: '', //第一期比例
                     periods: '', //期数
                     lastMoney: '', //最后一期补贴金额
                     isOver: '', //是否结束
                    isHand: '',
                    startTime: '',
                    endTime: '',
                    remark: ''
                },
                STORE_code: STORE,
                STORE_search: STORE_SEARCH,
                SHOP_code: SHOP,
                SHOP_search: SHOP_SEARCH,
                getOrgType: false,
                USER_code: USER,
                USER_search: USER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopIncomeVoucherState: 'add',
                shopIncomeVoucherStates: {
                    add: '新建补贴凭证',
                    check: '查看补贴凭证',
                    edit: '修改补贴凭证'
                },
                srcList: [''],
                multipleSelection: [],
                shopIncomeVoucherList: [],
                shopIncomeVoucher: {
                    id: '', //
                    userId: '', //用户ID
                    orgType: 2, //组织类型(1店铺,2门店)
                    orgId: '', //组织ID
                    orderId: '', //订单ID
                    money1: '', //消费凭证
                    money2: '', //贡献值
                    money3: '', //消费券额度
                    money4: '', //动券宝额度
                    firstRatio: 0.015, //第一期比例
                    periods: 0, //期数
                    lastMoney: 0, //最后一期补贴金额
                    isOver: 0, //是否结束
                    money: '',
                    serviceRadio: '',
                    isSend: 0,
                    consumptionType: ''
                },
                btnLoading: false,
                header: {
                    token: localStorage.getItem('token')
                },
                action: UPLOAD_API + UPLOAD_PATH,
                rules: {
                    userId: [{ required: true, validator: checkUser, trigger: 'blur' }],
                    orgType: [{ required: true, message: '组织类型(1店铺,2门店)不能为空', trigger: 'blur' }],
                    orgId: [{ required: true, validator: checkUser, trigger: 'blur' }],
                    orderId: [{ required: true, message: '订单id不能为空', trigger: 'blur' }],
                    money1: [{ required: true, message: '消费凭证不能为空', trigger: 'blur' }],
                    money2: [{ required: true, message: '贡献值不能为空', trigger: 'blur' }],
                    money3: [{ required: true, message: '消费券额度不能为空', trigger: 'blur' }],
                    money4: [{ required: true, message: '动券宝额度不能为空', trigger: 'blur' }],
                    firstRatio: [{ required: true, message: '第一期比例不能为空', trigger: 'blur' }],
                    periods: [{ required: true, message: '期数不能为空', trigger: 'blur' }],
                    lastMoney: [{ required: true, message: '最后一期补贴金额不能为空', trigger: 'blur' }],
                    isOver: [{ required: true, message: '是否结束不能为空', trigger: 'blur' }],
                    money: [{ required: true, message: '消费金额金额不能为空', trigger: 'blur' }],
                    serviceRadio: [{ required: true, message: '服务费类型不能为空', trigger: 'blur' }],
                    isSend: [{ required: true, message: '是否发放不能为空', trigger: 'blur' }],
                    consumptionType: [{ required: true, message: '消费类型不能为空', trigger: 'blur' }],
                    remark: [{ required: true, message: '备注不能为空', trigger: 'blur' }]
                },
                showRecordDialog: false,
                serviveTypeList: [],
                timeRange: [],
                countObj: {
                    money1Count: 0,
                    money2Count: 0,
                    money3Count: 0,
                    money4Count: 0
                }
            };
        },
        created() {
            this.getShopIncomeVoucherList();
            this.getEnum();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            openRecordDialog(id){
                this.showRecordDialog = true;
                this.$nextTick(() => {
                    this.$refs.record.init(id);
                })
            },
            getEnum(){
                get('/shop/utils/getEnum?enumType=store_service_type').then((res) => {
                    if (res.success && res.code == 200) {
                        this.serviveTypeList = res.enumList;
                    }
                })
            },
            closeRecordDialog(){
                this.showRecordDialog = false;
            },
            beforeImageUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 50;
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 50MB!');
                }
                return isLt2M;
            },
            //上传缩略图
            uploadImage(params) {
                const file = params.file;
                let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
                if (!types.includes(file.type)) {
                    this.$message.error('图片类型错误!');
                }
                const formData = new FormData();
                formData.append('file', file);
                upload(UPLOAD_PATH, formData).then((res) => {
                    if (res.success) {
                        this.shopIncomeVoucher.money1 = res.url;
                    }
                });
            },
            resetShopIncomeVoucherList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopIncomeVoucherList = [];
            },
            // 大图预览
            updateSrcList(src) {
                this.srcList[0] = src
            },
            resetDialog() {
                this.shopIncomeVoucherState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      userId: '', //用户ID
                      orgType: '', //组织类型(1店铺,2门店)
                      orgId: '', //组织ID
                      orderId: '', //订单ID
                      money1: '', //消费凭证
                      money2: '', //贡献值
                      money3: '', //消费券额度
                      money4: '', //动券宝额度
                      firstRatio: '', //第一期比例
                      periods: '', //期数
                      lastMoney: '', //最后一期补贴金额
                      isOver: '', //是否结束
                    isHand: '',
                    startTime: '',
                    endTime: '',
                    remark: ''
                };
                this.timeRange = [];
                this.getShopIncomeVoucherList();
            },
            closeDialog() {
                this.showDialog = false
                this.shopIncomeVoucher = {
                      id: '', //
                      userId: '', //用户ID
                      orgType: 2, //组织类型(1店铺,2门店)
                      orgId: '', //组织ID
                      orderId: '', //订单ID
                      money1: '', //消费凭证
                      money2: '', //贡献值
                      money3: '', //消费券额度
                      money4: '', //动券宝额度
                    firstRatio: 0.015, //第一期比例
                    periods: 0, //期数
                    lastMoney: 0, //最后一期补贴金额
                    isOver: 0, //是否结束
                    money: '',
                    serviceRadio: '',
                    isSend: 0,
                    consumptionType: ''
                };
            },
            submitForm() {
                if (this.shopIncomeVoucherState == 'add') {
                    this.$refs.shopIncomeVoucherForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/incomevoucher/add`,{ ...this.shopIncomeVoucher }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopIncomeVoucherList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopIncomeVoucherState == 'edit') {
                    this.$refs.shopIncomeVoucherForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/incomevoucher/edit`,{ ...this.shopIncomeVoucher }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopIncomeVoucherList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addShopIncomeVoucher() {
                this.showDialog = true;
                this.shopIncomeVoucherState = 'add';
            },
            checkShopIncomeVoucher(shopIncomeVoucherId) {
                console.log(shopIncomeVoucherId);
                this.currentShopIncomeVoucherId = shopIncomeVoucherId;

                this.getShopIncomeVoucherById();
                this.showDialog = true;
                this.shopIncomeVoucherState = 'check';
            },
            editShopIncomeVoucher(shopIncomeVoucherId) {
                console.log('shopIncomeVoucher', shopIncomeVoucherId);
                if (shopIncomeVoucherId) {
                    this.currentShopIncomeVoucherId = shopIncomeVoucherId;
                    this.getShopIncomeVoucherById();
                } else {
                    this.shopIncomeVoucher = { ...this.shopIncomeVoucher, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopIncomeVoucherState = 'edit';
            },
            deleteShopIncomeVoucher(shopIncomeVoucherId) {
                let ids = '';
                if (shopIncomeVoucherId) {
                    ids = shopIncomeVoucherId;
                } else {
                    ids = this.multipleSelection.map((shopIncomeVoucher) => shopIncomeVoucher.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/shop/incomevoucher/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopIncomeVoucherList();
                                this.getShopIncomeVoucherList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshShopIncomeVoucherList() {
                this.resetShopIncomeVoucherList();
                this.getShopIncomeVoucherList();
            },
            getShopIncomeVoucherList(query = {}) {
                this.loading = true;
                if (this.timeRange.length != null) {
                    this.queryForm.startTime = this.timeRange[0];
                    this.queryForm.endTime = this.timeRange[1];
                }
                get(`/shop/incomevoucher/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopIncomeVoucherList = res.page.list;
                        this.totalNum = res.page.total;
                        if(res.moneyCounts){
                            this.countObj = res.moneyCounts;
                        }else{
                            this.countObj= {
                                money1Count: 0,
                                money2Count: 0,
                                money3Count: 0,
                                money4Count: 0
                            }
                        }
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopIncomeVoucherById() {
                get(`/shop/incomevoucher/get`,{ id: this.currentShopIncomeVoucherId }).then((res) =>{
                    if(res.success){
                      this.getOrgType = true;
                      this.shopIncomeVoucher = { ...this.shopIncomeVoucher, ...res.shopIncomeVoucher };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopIncomeVoucherList() {
                //this.btnLoading = true;
                exprotExcel(`/shop/incomevoucher/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/shop/incomevoucher/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/shop/incomevoucher/importData`,formData);
              this.refreshShopIncomeVoucherList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopIncomeVoucherList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopIncomeVoucherList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.avatar {
    width: 130px;
    height: 130px;
    display: block;
}

::v-deep .el-upload--text {
    width: 130px;
    height: 130px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

::v-deep .el-range-separator {
    width: 20px;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 130px;
    height: 130px;
    line-height: 130px;
    text-align: center;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
.count{
    font-size: 14px;
    margin-left: 10px;
    padding: 0 4px;
}
</style>